import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductCard from '../../../components/product/ProductCard';
import _ from 'lodash';
import {fetchMaterial} from '../../../assets/util'
import {load} from '../../../actions/common'

class RelateProductList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            related_products : [],
        };
    }

    componentDidMount(){
        fetchMaterial({mat_var_id: this.props.matVarId}, null, 1, 4, {wrap: false, sortWithMatVarId: true})
        .then((response) => response.json())
        .then((products) => this.setState({related_products: products.data}))
    }

    componentDidUpdate(prevProps){
        if(!_.isEqual(prevProps.matVarId, this.props.matVarId)){
            this.props.load(true)
            fetchMaterial({mat_var_id: this.props.matVarId}, null, 1, 4, {wrap: false, sortWithMatVarId: true})
            .then((response) => response.json())
            .then((products) => {this.setState({related_products: products.data}); this.props.load(false)})
        }
    }

    render() {
        const { related_products } = this.state
        const {newTab} = this.props
        return (
            _.map(related_products, (product, index)=>{
                return <div key={`rp_${index}`} className="col-5 col-md-3">
                    <ProductCard item={product} showWishlist={false} showRating={false} showPromotion={false} lazyLoad={false}  showAddToCartText={false} newTab={newTab} /> 
                </div>
            })
        )
    }
};

function mapStateToProps(state) {
    return {
    }
}
export default connect(mapStateToProps, { load })(RelateProductList)